module.exports = __webpack_public_path__ + "assets/img/bake_active.11c1b929.png";